import { memo, MouseEventHandler } from 'react';

import { TableToolsBar } from '@/lib/v2/organisms';

import { useActionBar } from '@/src/modules/AutomationModuleNew/hooks/useActionBar';

export enum EActionBarButtons {
  EDIT = 'edit',
  DELETE = 'delete',
  DUPLICATE = 'duplicate',
}

type ActionBarJourneyMessagesProps = {
  totalRowSelected: number;
  showDownloadButton?: boolean;
  onClickDownload?: MouseEventHandler<HTMLButtonElement>;
  hideButtons?: EActionBarButtons[];
};

const ActionBar = ({
  totalRowSelected,
  showDownloadButton = false,
  onClickDownload,
  hideButtons = [],
}: ActionBarJourneyMessagesProps) => {
  const { actions } = useActionBar({
    totalRowSelected,
    showDownloadButton,
    onClickDownload,
    hideDeleteButton: hideButtons.includes(EActionBarButtons.DELETE),
    hideEditButton: hideButtons.includes(EActionBarButtons.EDIT),
    hideDuplicateButton: hideButtons.includes(EActionBarButtons.DUPLICATE),
  });

  return (
    <TableToolsBar>
      {actions
        .filter((element) => !element.hide)
        .map((element) => {
          const { label, icon, tooltip, onClick: handleOnClick, id } = element;
          return (
            <TableToolsBar.Button
              key={id}
              icon={icon}
              id={id}
              label={label}
              tooltip={tooltip}
              onClick={handleOnClick}
            />
          );
        })}
    </TableToolsBar>
  );
};

export default memo(ActionBar);
